/**
 * Render list of companies available for user to create an employer profile
 */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import OnboardingCompanyRadioButton from './OnboardingCompanyRadioButton';
import { companySelected, createProfile } from '../actions/userCompanyActions';
import { connect } from 'react-redux';
import cx from 'classnames';

export class OnboardingCompanyResult extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        selectedCompany: PropTypes.object,
        userCompanies: PropTypes.array.isRequired,
    };

    registerSelectedCompany(company) {
        this.props.dispatch(companySelected(company));
    }

    onClick() {
        this.props.dispatch(
            createProfile(this.props.selectedCompany.companyId)
        );
    }

    renderCompanies() {
        return this.props.userCompanies.map((company, i) => {
            const checked = i === 0;

            return (
                <OnboardingCompanyRadioButton
                    {...company}
                    checked={checked}
                    key={`comp-${i}`}
                    registerSelectedCompany={this.registerSelectedCompany.bind(
                        this
                    )}
                />
            );
        });
    }

    renderConfirmationText() {
        return (
            <div className="centerify licorice r-mtl">
                {
                    i18n[
                        'By going further confirm that I work in this company, and that I have the right to create this profile on behalf of my company'
                    ]
                }
            </div>
        );
    }

    render() {
        const companies = this.renderCompanies();
        const canSubmit = this.props.selectedCompany !== null;

        return (
            <React.Fragment>
                {companies}
                <div className="u-pv32">
                    <button
                        className={cx('button', {
                            'button--cta': canSubmit,
                            'button--is-disabled': !canSubmit,
                        })}
                        disabled={!canSubmit}
                        onClick={this.onClick.bind(this)}
                        ref="submitProfile"
                        style={{ width: '100%' }}
                        type="submit"
                    >
                        {i18n['Create a profile']}
                    </button>
                    {canSubmit ? this.renderConfirmationText() : null}
                </div>
            </React.Fragment>
        );
    }
}

export default connect(() => ({}))(OnboardingCompanyResult);
